<template>
  <DashboardCard ref="dashboardCard">
    <img
      src="@/assets/images/icon_graph_type_radio.svg"
      alt="Gráfico de arcos"
      slot="icon"
    />
    <span slot="title">Relatório geral - {{ model }}</span>

    <div slot="controls">
      <p class="text-dark">Modelos de veiculação</p>
      <OptionList
        :options="graphTypeOptions"
        v-model="model"
        @change="$refs.dashboardCard.closeControls()"
      />
    </div>

    <b-row class="h-100 flex-column">
      <b-col cols="auto" text-center>
        <p class="description-graph">
          {{ graphData.descriptionText }}
        </p>
      </b-col>
      <b-col>
        <div >
          <!--class="h-100 d-flex flex-column justify-content-center"-->
          <span v-if="series">
            <apexchart
              type="radialBar"
              :height="height"
              :options="chartOptions"
              :series="series"
            />
          </span>
          <span v-else class="row justify-content-center">
            <Loader :width="loaderWidth"></Loader>
          </span>
        </div>
      </b-col>
    </b-row>
  </DashboardCard>
</template>

<script>
import Loader from '@/components/Loader';
import OptionList from './OptionList';
import DashboardCard from './DashboardCard';

export default {
  name: 'PerformanceGraph',
  components: {
    OptionList,
    DashboardCard,
    Loader,
  },
  data() {
    return {
      series: '',
      chartOptions: '',
      model: 'CPA',
      showOptions: false,
      loaderWidth: 200,
    };
  },
  props: {
    graphData: Object,
    height: String,
  },
  computed: {
    graphTypeOptions() {
      return Object.keys(this.graphData.data).map(type => ({
        name: type,
        value: type,
      }));
    },
  },
  methods: {
    setChartOptions(model) {
      this.model = !model ? this.model : model;
      this.series = this.graphData.data[this.model].map(item => item.value);

      return {
        plotOptions: {
          radialBar: {
            offsetX: 18,
            offsetY: -20,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 0,
              size: '30%',
              background: 'transparent',
              image: undefined,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        colors: this.graphData.colors,
        labels: this.graphData.data[this.model].map(item => item.type),
        legend: {
          show: true,
          floating: true,
          fontSize: '12px',
          position: 'left',
          offsetX: -30,
          offsetY: -27,
          labels: {
            colors: ['#000'],
            useSeriesColors: false,
          },
          markers: {
            width: 10,
            height: 10,
          },
          formatter(seriesName, opts) {
            return `&nbsp;&nbsp;${seriesName}: ${
              opts.w.globals.series[opts.seriesIndex]
            }
                    `;
          },
          itemMargin: {
            horizontal: 1,
            vertical: 3,
          },
        },
        responsive: [],
      };
    },
  },
  watch: {
    model: {
      handler(model) {
        this.chartOptions = this.setChartOptions(model);
      },
    },
    graphData: {
      immediate: true,
      deep: true,
      handler() {
        this.chartOptions = this.setChartOptions();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.description-graph {
  font-size: $font-size-lg-small;
}
</style>
